import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { NotificationCode } from '../../models/communication/app-enums.model';
import { NotificationTextPipe } from '../../pipes/notification-text.pipe';

@Component({
    selector: 'app-notification',
    standalone: true,
    imports: [CommonModule, NotificationTextPipe],
    templateUrl: './notification.component.html',
    styleUrl: './notification.component.scss'
})
export class NotificationComponent {
    @Input() code?: NotificationCode;
    @Input() severity = '';
    @Input() canClose = false;

    @Output()
    readonly closeClicked = new EventEmitter<void>();
}
